import { useEffect, useState } from 'react';

export interface ApiPermission {
  id: string;
  code: string;
  module: string;
  entity: string;
  action: string;
  description: string;
}

// Fetches the real permissions catalog from GET /permissions-list. Each
// entity (e.g. "cuadro_de_mando") has a "_read" and an "_all" row — the two
// levels behind the existing 'none' | 'view' | 'full' privilege model.
export const useApiPermissions = () => {
  const [permissions, setPermissions] = useState<ApiPermission[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchPermissions = async () => {
      setLoading(true);
      setError(false);
      try {
        const Cookies = (await import('universal-cookie')).default;
        const cookies = new Cookies();
        const userCookie = cookies.get('101Obex');
        if (!userCookie || !userCookie.token) {
          setError(true);
          return;
        }

        const ObexRequestsHandlerP80 = (await import('../handlers/ObexRequestsHandlerP80')).default;
        let res = await ObexRequestsHandlerP80.get('/permissions-list', { access_token: userCookie.token });
        if (res.data) res = res.data;

        const rows = res?.response ?? res?.result?.response;
        if (Array.isArray(rows)) {
          setPermissions(rows.map((p: any) => ({
            id: String(p.id),
            code: p.code,
            module: p.module,
            entity: p.entity,
            action: p.action,
            description: p.description || '',
          })));
        } else {
          setError(true);
        }
      } catch (fetchError) {
        console.error('Error fetching permissions:', fetchError);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchPermissions();
  }, []);

  return { permissions, loading, error };
};
